import { Alert, Box } from '@mui/material';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LocationFormContext } from '../../context';
import { getApproachLanes } from './utils';
import { useStyles } from './styles';
import { ManeuverLaneAccordion } from './ManeuverLaneAccordion/ManeuverLaneAccordion';
import { useDynamicDocumentationLink } from 'components/layouts';

export const Maneuvers = () => {
  const { t } = useTranslation(['locations', 'common']);
  const classes = useStyles();
  const { values } = useContext(LocationFormContext);

  useDynamicDocumentationLink({ link: 'LOCATIONS_ADD_MANEUVERS' });

  const approachLanes = useMemo(() => getApproachLanes(values?.lanes ?? []), [values?.lanes]);

  const getManeuversByApproach = (id?: string) =>
    values?.maneuvers?.filter((maneuver) => maneuver.refApproachLane === id);

  return (
    <>
      {approachLanes.length === 0 ? (
        <Alert severity='info'>{t('emptyManeuverLaneMessage')}</Alert>
      ) : (
        <Box className={classes.lanes}>
          {approachLanes.map((lane) => {
            const maneuvers = getManeuversByApproach(lane.id);
            return (
              <Box key={lane.id}>
                {!maneuvers?.length ? (
                  <Alert severity='warning'>
                    <b>{lane.description}</b>
                    <br />
                    {t('emptyManeuverMessage')}
                  </Alert>
                ) : (
                  <ManeuverLaneAccordion lane={lane} maneuvers={maneuvers} />
                )}
              </Box>
            );
          })}
        </Box>
      )}
    </>
  );
};
